// extracted by mini-css-extract-plugin
export default {"example":"WordEntry_example__YV-Gx","highlight":"WordEntry_highlight__B9AEl","definition":"WordEntry_definition__hKA8d","link":"WordEntry_link__43nOx"};